import { Sine, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { GalleryHieroglyphData } from "../Data/GalleryHieroglyphData";
import { NightFilter } from "../Filters/NightFilter";
import { HieroglyphLayer } from "../GameObjects/HieroglyphLayer";
import { HieroglyphWeather, WeatherType } from "../GameObjects/HieroglyphWeather";

export class HieroglyphCanvas extends PIXI.Container {
    private _bg: PIXI.Sprite;
    private _layerContainer: PIXI.Container;
    private _layers!: HieroglyphLayer[];
    private _weather!: HieroglyphWeather;
    private _frame!: PIXI.Container;
    private _overlay!: PIXI.Sprite;
    private _nightFilter: NightFilter;

    constructor() {
        super();

        this._bg = HLF.PixiUtils.makeSprite("bg", Constants.SPRITESHEET_HIERO_PREFIX + "02");
        this.addChild(this._bg);

        this._layerContainer = new PIXI.Container();
        this.addChild(this._layerContainer);

        this._layers = new Array<HieroglyphLayer>(3);

        for (let i = 0; i < this._layers.length; ++i) {
            this._layers[i] = (new HieroglyphLayer(i));
            this._layers[i].position.set(0, 0);
            this._layerContainer.addChild(this._layers[i]);
        }

        this._weather = new HieroglyphWeather();
        this.addChild(this._weather);

        this._frame = new PIXI.Container();
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-bottom", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-top", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-left", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-right", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this.addChild(this._frame);

        this._overlay = HLF.PixiUtils.makeSprite("texture-overlay", Constants.SPRITESHEET_HIERO_PREFIX + "02");
        this._overlay.scale.set(2);
        this.addChild(this._overlay);

        this._nightFilter = new NightFilter(PIXI.loader.resources["colour-ramp-night"].texture);
    }

    public setupForOnboarding(pIsOnboarding: boolean): void {
        if (pIsOnboarding) {
            this._layers[0].hide(true);
            this._layers[1].hide(true);
            this._layers[2].hide(true);
        }
    }

    public update(pDeltaTime: number): void {
        this._weather.update(pDeltaTime);
    }

    public updateLayer(pLayerIndex: number, pContentIndex: number, pInstantly: boolean = false): void {
        if (this._layers[pLayerIndex].isHidden) {
            this._layers[pLayerIndex].show();
            this._layers[pLayerIndex].setContent(pContentIndex, true);
        }
        else {
            this._layers[pLayerIndex].setContent(pContentIndex, pInstantly);
        }
    }

    public updateColour(pColourIndex: number): void {
        this._layers[2].setColourIndex(pColourIndex);
    }

    public updateWeather(pWeatherIndex: number, pInstantly: boolean = false): void {
        this._weather.setWeather(pWeatherIndex, pInstantly);
        this._layerContainer.filters = pWeatherIndex === WeatherType.NIGHT ? [ this._nightFilter ] : [];
    }

    public generateSaveData(): GalleryHieroglyphData {
        const contentIndeces: number[] = new Array<number>();
        for (let i = 0; i < this._layers.length; ++i) {
            contentIndeces.push(this._layers[i].contentIndex);
        }
        return new GalleryHieroglyphData(contentIndeces, this._layers[2].colourIndex, this._weather.weatherIndex);
    }
}
